import {
  INDUSTRY_OPTIONS,
  USER_ROLE_OPTIONS,
  type StoredReport,
} from '../types/discovery.types';

// Value → human label maps so a report title reads like its subject.
const INDUSTRY_LABELS: Record<string, string> = Object.fromEntries(
  INDUSTRY_OPTIONS.map((o) => [o.value, o.label]),
);
const ROLE_LABELS: Record<string, string> = Object.fromEntries(
  USER_ROLE_OPTIONS.map((o) => [o.value, o.label]),
);

/** Strip the report file extension for the display fallback. */
export function reportFileStem(fileName: string): string {
  return fileName.replace(/\.(pdf|docx)$/i, '');
}

/**
 * Human report title — shared by the My Reports list and the Book a Meeting
 * "Reports to discuss" list so they always match. Reflects the report subject
 * (Industry · Role · Country), not the company name (usually the user's own org).
 */
export function reportTitle(r: StoredReport): string {
  const parts = [
    r.industry ? INDUSTRY_LABELS[r.industry] ?? r.industry : '',
    r.userRole ? ROLE_LABELS[r.userRole] ?? r.userRole : '',
    r.country ?? '',
  ].filter(Boolean);
  return parts.length ? parts.join(' · ') : reportFileStem(r.fileName);
}
